import clsx from 'clsx';
import React from 'react';

interface OnboardingTabItem {
    id: number;
    title: string;
}

interface Props {
    tabs: OnboardingTabItem[];
    activeIndex: number;
    onTabChange: (index: number) => void;
}

const OnboardingTabBar: React.FC<Props> = ({ tabs, activeIndex, onTabChange }) => {
    return (
        <div className="flex gap-2 overflow-x-auto pb-1">
            {tabs.map((tab, index) => (
                <button
                    key={tab.id}
                    type="button"
                    onClick={() => onTabChange(index)}
                    className={clsx(
                        'whitespace-nowrap rounded-lg px-4 py-2 text-sm font-medium transition-colors',
                        index === activeIndex
                            ? 'bg-theme-primary text-theme-on-primary'
                            : 'bg-gray-100 text-gray-600 hover:bg-gray-200',
                    )}
                >
                    {tab.title}
                </button>
            ))}
        </div>
    );
};

export default OnboardingTabBar;
